import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, removeToken } from './auth'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: { 'Content-Type': 'application/json' },
  timeout: 1000 * 60
})

service.interceptors.request.use(
  config => {
    config.headers['Authorization'] = 'Bearer ' + getToken()
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    // console.log(res.code, "res")
    if (res.code === 401) {
      removeToken()
      localStorage.removeItem('user')
      window.location.href = '/login'
    } else if (res.code !== 100000) {
      Message({
        message: res.msg || 'Error222:' + res.code,
        type: 'error',
        duration: 5 * 1000
      })

      return Promise.reject(new Error(res.message || 'Error2111'))
    } else {
      return res
    }
  },
  error => {
    var msg = String(error)
    console.log(msg, 'msg')
    if (msg.indexOf('400') != -1) { msg = '账号或密码错误,或没有权限!' }
    if (msg.indexOf('401') != -1) {
      removeToken()
      localStorage.removeItem('user')
      // window.location.href="/#/login";
      window.location.href = '/login'
    }
    if (msg.indexOf('403') != -1) { msg = '您的账号没有权限!' }
    Message({
      message: msg,
      type: 'error',
      duration: 5 * 1000
    })

    return Promise.reject(error)
  }
)

export default service
